import { DropdownFoldMenu } from 'components/Dropdown/menus/Fold/DropdownFoldMenu';
import { useUser } from 'contexts/UserEnvironmentContext';
import { postOnIdealistDropdownDataByLocale } from 'mappings/PostOnIdealistDropdown/postOnIdealistDropdownDataByLocale';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from 'routing/route-constants';

import {
  postOnIdealistDropdownDataByResourcesItemType,
  postOnIdealistDropdownDataBySearchItemType,
} from './postOnIdealistDropdownConstants';

type Props = {
  locale: UserLocale;
  trackClickedContext: string;
  excludeQaId?: string;
};

export function PostOnIdealistDropdownMenu({
  locale,
  trackClickedContext,
  excludeQaId,
}: Props) {
  const { user } = useUser();
  const { search, resources } = postOnIdealistDropdownDataByLocale[locale];

  return (
    <DropdownFoldMenu
      left={{
        title: search.title,
        items: search.items
          .map((searchItem) => {
            const { iconName, qaId, trackClickedName } =
              postOnIdealistDropdownDataBySearchItemType[searchItem.type];

            if (excludeQaId && qaId === excludeQaId) {
              return null;
            }

            return {
              iconName,
              title: searchItem.title,
              href: user
                ? searchItem.href
                : SIGN_UP_TO_POST_URL_FOR_LOCALE[locale],
              qaId,
              trackClicked: {
                name: trackClickedName,
                context: trackClickedContext,
              },
            };
          })
          .filter(Boolean),
      }}
      right={{
        title: resources.title,
        items: resources.items.map((resourceItem) => {
          const { image, imageHover, qaId, trackClickedName } =
            postOnIdealistDropdownDataByResourcesItemType[resourceItem.type];

          return {
            image,
            imageHover,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
            qaId,
            trackClicked: {
              name: trackClickedName,
              context: trackClickedContext,
            },
          };
        }),
      }}
    />
  );
}
